exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".App {\n}\n\n.LessonsIndex table button {\n    margin-right: 3px;\n}\n\n.table > tbody > tr > td {\n    vertical-align: middle;\n}\n\n.table.selectable > tbody > tr.active > td {\n    background: #5599CC !important;\n}\n\n.modal .modal-body {\n    max-height: 466px;\n    overflow: auto;\n}\n\n@media (min-width: 768px) {\n    .large-dialog .modal-dialog {\n        width: 740px !important;\n    }\n}\n\n@media (min-width: 992px) {\n    .large-dialog .modal-dialog {\n        width: 950px !important;\n    }\n}\n\n@media (min-width: 1200px) {\n    .large-dialog .modal-dialog {\n        width: 1144px !important;\n    }\n}\n\n.form-horizontal .large-dialog .form-group {\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n}\n\n.unselectable {\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    /*noinspection CssUnknownProperty*/\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1!./~/postcss-loader!./src/components/App.css
// module id = 673
// module chunks = 0